module.exports = __webpack_public_path__ + "img/race-page_900.9a0f9463.png";